import { jsx as c, jsxs as d } from "react/jsx-runtime";
import { c as m } from "react/compiler-runtime";
const p = (h) => {
  const e = m(10), {
    size: l,
    x: s,
    y: F,
    color: f
  } = h, n = f === void 0 ? "#DB5E04" : f;
  let i;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (i = /* @__PURE__ */ c("path", { d: "M13.7 3.5a2 2 0 0 0-3.4 0L1.6 18.5A2 2 0 0 0 3.3 21.5h17.4a2 2 0 0 0 1.7-3L13.7 3.5z", fill: "#FFFFFF" }), e[0] = i) : i = e[0];
  let t;
  e[1] !== n ? (t = /* @__PURE__ */ c("path", { d: "M13 4.5a1.2 1.2 0 0 0-2 0L3.1 18.6a1.2 1.2 0 0 0 1 1.8h15.8a1.2 1.2 0 0 0 1-1.8L13 4.5z", fill: n }), e[1] = n, e[2] = t) : t = e[2];
  let a, o;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (a = /* @__PURE__ */ c("rect", { x: "11", y: "9", width: "2", height: "6", rx: "1", fill: "#FFFFFF" }), o = /* @__PURE__ */ c("circle", { cx: "12", cy: "17.5", r: "1.2", fill: "#FFFFFF" }), e[3] = a, e[4] = o) : (a = e[3], o = e[4]);
  let r;
  return e[5] !== l || e[6] !== t || e[7] !== s || e[8] !== F ? (r = /* @__PURE__ */ d("svg", { x: s, y: F, width: l, height: l, viewBox: "0 0 24 24", focusable: "false", "aria-hidden": "true", "data-testid": "WarningBadgeIcon", children: [
    i,
    t,
    a,
    o
  ] }), e[5] = l, e[6] = t, e[7] = s, e[8] = F, e[9] = r) : r = e[9], r;
};
export {
  p as default
};
